import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { MenuItem } from "@material-ui/core";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Typography from "@material-ui/core/Typography";
import { CSSTransition } from "react-transition-group";
import { useHistory } from "react-router";

import supportedOrganisations from "../../constants";

import * as AuthService from "../../services/auth-service";

export default function Register(props) {
    const history = useHistory();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPass, setConfirmPass] = useState("");
    const [org, setOrg] = useState("na");
    const [formError, setFormError] = useState(null);
    const user = useSelector((state) => state.user);
    const emailUpdateHandler = (event) => {
        setEmail(event.target.value);
    };
    const passwordUpdateHandler = (event) => {
        setPassword(event.target.value);
    };
    const confirmPassUpdateHandler = (event) => {
        setConfirmPass(event.target.value);
    };
    const submitHandler = (event) => {
        event.preventDefault();
        setFormError(null);
        if (password !== confirmPass) {
            setFormError("Passwords do not match!");
        } else {
            // First - check if the agent with such email exists
            // validate email will return true if exists, false otherwise
            AuthService.validateEmail(email).then((response) => {
                if (response) {
                    AuthService.register(email, password, org)
                        .then((response) => {
                            // On successful creation (201)
                            history.push({
                                pathname: "/login/",
                                state: {
                                    message: "Account registered successfully! Please follow email instructions to activate it.",
                                    status: 201,
                                },
                            });
                        })
                        .catch((error) => {
                            // The returned error will be displayed here (400)
                            let errorMessage = "An error has occured";
                            if (error?.response?.data?.message) {
                                errorMessage = error?.response?.data?.message
                            }
                            setFormError(errorMessage);
                        });
                } else {
                    setFormError("Invalid email. Please make sure to use your agency email to continue.")
                }
            })
            
        }
    };

    return (
        <React.Fragment>
            <Typography component="p" variant="body1">
                Please use your ListOnce email to create an account for
                ReportOnce
            </Typography>
            {user.errorMessage ? (
                <Typography variant="body1" component="p" color="error">
                    {user.errorMessage}
                </Typography>
            ) : (
                ""
            )}
            {formError ? (
                <Typography variant="body1" component="p" color="error">
                    {formError}
                </Typography>
            ) : (
                ""
            )}
            <form className={props.classes.loginForm} onSubmit={submitHandler}>
                <TextField
                    className={props.classes.loginInput}
                    id="org"
                    select
                    label="Your organisation"
                    onChange={(e) => {setOrg(e.target.value)}}
                    type="org"
                    value={org}
                >
                    {supportedOrganisations.map((option) => (
                        <MenuItem key={option.value} value={option.value}>
                            {option.label}
                        </MenuItem>
                    ))}
                </TextField>
                <TextField
                    className={props.classes.loginInput}
                    id="email"
                    label="Email Address"
                    onChange={emailUpdateHandler}
                    type="email"
                    value={email}
                />
                <TextField
                    className={props.classes.loginInput}
                    id="password"
                    label="Password"
                    onChange={passwordUpdateHandler}
                    type="password"
                    value={password}
                />
                <TextField
                    className={props.classes.loginInput}
                    id="confirmPass"
                    label="Confirm Password"
                    onChange={confirmPassUpdateHandler}
                    type="password"
                    helperText="Your password must contain at least 8 characters, be different from your username and not be entirely numeric"
                    value={confirmPass}
                />
                <Button
                    className={props.classes.loginButton}
                    color="primary"
                    type="submit"
                    variant="contained"
                >
                    Sign Up
                </Button>
            </form>
            <Button
                className={props.classes.signUp}
                color="primary"
                component={Link}
                to="/login"
                variant="text"
            >
                Back
            </Button>
            <Typography
                className={props.classes.poweredBy}
                component="p"
                variant="caption"
            >
                Powered by ListOnce
            </Typography>
            <CSSTransition
                appear
                classNames="fade-animation"
                in={loading}
                key="login-loading"
                timeout={1000}
                unmountOnExit
            >
                <div className={props.classes.loginLoadingOverlay}>
                    <CircularProgress />
                </div>
            </CSSTransition>
        </React.Fragment>
    );
}
